const MERCHANDISE_DATA = {
  "gid://shopify/Product/6978687631552": {
    type: "merchandise",
    title: "Stop, Drop and Betty Rock Shaker Bottle",
    img: ["sdbr-bottle"],
    collection: "merchandise",
    collectionInfo: "merchandise",
    care: "Wash with warm, soapy water. Rinse and dry. Dishwasher safe.",
  },
  "gid://shopify/Product/7024694788288": {
    type: "merchandise",
    title: "Love Your Body Shaker Bottle",
    img: ["love-you-body-bottle"],
    collection: "merchandise",
    collectionInfo: "merchandise",
    care: "Wash with warm, soapy water. Rinse and dry. Dishwasher safe.",
  },
  "gid://shopify/Product/6978694152384": {
    type: "merchandise",
    title: "30-Day Challenge Tracker Erasable Board",
    img: ["memory-board"],
    collection: "merchandise",
    collectionInfo: "merchandise",
    care: "Use water and a paper towel to wipe off text, and wipe dry.",
  },
  "gid://shopify/Product/7353488703680": {
    type: "merchandise",
    title: "All or Something Reusable Grocery Tote",
    img: ["all-or-something-tote"],
    collection: "merchandise",
    collectionInfo: "merchandise",
  },
  // "gid://shopify/Product/6978698215616": {
  //   type: "merchandise",
  //   title: "Eat Better Reusable Grocery Tote",
  //   img: ["grocery-tote"],
  //   collection: "merchandise",
  //   collectionInfo: "merchandise",
  // },
}
export default MERCHANDISE_DATA
